import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/landingpage";
import Enterprise from "./pages/Enterprise";
import { ContractorPage } from "./pages/contractor/ContractorPage";
import { HomePage } from "./pages/homepage/HomePage";
import NotFound from "./pages/NotFound";
import Login from "./pages/login";
import { useContext } from "react";
import { AuthContext } from "context";
import Banner from "components/Banner";
import Referrals from "./pages/referrals";
import Redirect from "pages/referrals/Redirect";
import ContactUs from "pages/contact";
import { DoctorsPage, EnterprisePage } from "pages";
import { Layout, NewLayout } from "components";
import { OwnerPage } from "pages/owner/OwnerPage";
import { Pricing } from "pages/pricing/Pricing";
import EnterprisePlan from "pages/pricing/enterprise/EnterprisePlan";
import PremiumPlan from "pages/pricing/premium/PremiumPlan";
import { PrivacyPage } from "pages/privacy/PrivacyPage";
import { TermsPage } from "pages/terms/TermsPage";
import { SupportPage } from "pages/support/SupportPage";
import ScrollToTop from "components/ScrollToTop";
import AboutUs from "pages/aboutUs";
import Finance from "pages/finance";
import ScheduleCall from "pages/scheduleCall/index";
import CalendlyPage from "pages/scheduleCall/components/CalendlyPage";
import ThankYouPage from "pages/scheduleCall/components/ThankYouPage";
import Lenders from "pages/lenders";
import { ConsultantPage } from "pages/consultant/ConsultantPage";
import ProjectDevelopers from "pages/developers/ProjectDevelopers";
import DeleteAccount from "pages/deleteAccount";

function App() {
  let [auth] = useContext(AuthContext);
  return (
    <>
      <ScrollToTop />
      <Routes>
        {auth === true || !process.env.REACT_APP_IS_BNKLE ? (
          <>
            <Route path="/" element={<NewLayout />}>
              <Route index element={<HomePage />} />
              <Route path="owner" element={<OwnerPage />} />
              <Route path="/contractor" element={<ContractorPage />} />
              <Route path="/consultant" element={<ConsultantPage />} />
              <Route path="/developer" element={<ProjectDevelopers />} />
              <Route path="/contact" element={<ContactUs />} />
            </Route>

            <Route path="/finance" element={<Finance />} />
            <Route path="/schedule-call-calendly" element={<CalendlyPage />} />
            <Route path="/schedule-call" element={<ScheduleCall />} />
            <Route path="/waitlist-welcome" element={<ThankYouPage />} />
            <Route path="/canpad" element={<Navigate to={"/owner"} />} />
            <Route path="/referral">
              <Route path="" index element={<Referrals />} />
              <Route path=":refId" index element={<Redirect />} />
              <Route />
            </Route>
            <Route path="/" element={<NewLayout />}>
              <Route path="doctor" element={<DoctorsPage />} />
              <Route path="enterprise" element={<EnterprisePage />} />
              <Route path="policy" element={<PrivacyPage />} />
              <Route path="pricing" element={<Pricing />}>
                <Route index element={<Navigate to="enterprise" replace />} />
                <Route path="enterprise" element={<EnterprisePlan />} />
                <Route path="premium" element={<PremiumPlan />} />
              </Route>
              <Route path="/lender" element={<Lenders />} />
              <Route path="/about-us" element={<AboutUs />} />
            </Route>
          </>
        ) : null}
        {/* Public pages linked from external listings (Play Console's Data
            safety section, and the App Store / Play Store listings). Kept
            outside the auth gate above so they stay reachable without the
            app installed and without being signed in. */}
        <Route path="/" element={<NewLayout />}>
          <Route path="delete-account" element={<DeleteAccount />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="support" element={<SupportPage />} />
        </Route>
        <Route path="*" element={<NotFound />} />
        <Route path="/admin-login" element={<Login />} />
      </Routes>
    </>
  );
}

export default App;
